import { Grid } from "@mui/material";
import React from "react";
import FormContainer from "../../../components/FormContainer";
import InputField from "../../../components/input/InputField";
import InputCalendrier from "../../../components/inputCalendrier/InputCalendrier";
import Select from "../../../components/select/Select";
import { maxLocataireAge, minLocataireAge } from "../../../helpers/validators";
import Libelle from "../../../_i18n/fr.json";
import { Field } from "react-final-form";

interface IProps {
  qualites: { key: string; value: string; text: string }[];
  classes?: any;
}

const SituationPersonnelleConjointForm = (props: IProps) => {
  return (
    <>
      <h3>{Libelle.pageSituationPerso.sections.section3}</h3>
      <FormContainer>
        <Grid container spacing={2}>
          <Grid item>
            <Field
              name="qualiteConjoint"
              component={Select}
              options={props.qualites}
              label="Qualité"
              required
            />
          </Grid>
          <Grid item>
            <Field
              name="nomConjoint"
              component={InputField}
              label="Nom"
              maxLength={29}
              required
            />
          </Grid>
          <Grid item>
            <Field
              name="nomDeNaissanceConjoint"
              component={InputField}
              label="Nom de naissance"
              maxLength={29}
            />
          </Grid>
          <Grid item>
            <Field
              name="prenomConjoint"
              component={InputField}
              label="Prénom"
              maxLength={29}
              required
            />
          </Grid>
          <Grid item>
            <Field
              name="dateNaissanceConjoint"
              component={InputCalendrier}
              label="Date de naissance"
              minDate={maxLocataireAge}
              maxDate={minLocataireAge}
              required
              variante="inline"
              varianteInput="filled"
            />
          </Grid>
        </Grid>
      </FormContainer>
    </>
  );
};

export default SituationPersonnelleConjointForm;
